import { Row, Col, Card } from "antd"
import PropTypes from "prop-types"

Section.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  children: PropTypes.node,
  fullWidth: PropTypes.bool,
  extra: PropTypes.node,
  style: PropTypes.object,
  className: PropTypes.string
}

/**
  * Note: This component depends on the global styles defined in the Section.style.sass file
 */
export function Section ({
  children,
  title,
  fullWidth,
  extra = null,
  style = undefined,
  className,
  ...props
}) {
  const rowStyle = fullWidth ? { maxWidth: "100%", height: "100%" } : style

  return (
    <Row className={`fico section ${className}`} style={rowStyle}>
      <Col span={24}>
        <Card
          {...props}
          bordered={false}
          extra={extra}
          title={title}>
          {children}
        </Card>
      </Col>
    </Row>
  )
}
